/* unplugin-vue-components disabled */import { render } from "./Friend.vue?vue&type=template&id=c95946b8&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"

import "./Friend.vue?vue&type=style&index=0&id=c95946b8&lang=scss&scoped=true"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95946b8"]])

export default __exports__